import styled from 'styled-components'
import { Link } from 'gatsby'

export const TranscriptionLink = styled(Link)`
  margin-top: 5px;
  grid-column: 2 / 12;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration-line: none;
  font-style: normal;
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 1.71;
  letter-spacing: 0.02em;
  color: var(--highlight-blue);

  :hover {
    text-decoration-line: underline;
  }

  span {
    padding-left: 5px;
  }
`
